export default [
    {
        "city": "New York", 
        "state": "New York"
    }, 
    {
        "city": "Los Angeles", 
        "state": "California"
    }, 
    {
        "city": "Chicago", 
        "state": "Illinois"
    }, 
    {
        "city": "Houston", 
        "state": "Texas"
    }, 
    {
        "city": "Philadelphia", 
        "state": "Pennsylvania"
    }, 
    {
        "city": "Phoenix", 
        "state": "Arizona"
    }, 
    {
        "city": "San Antonio", 
        "state": "Texas"
    }, 
    {
        "city": "San Diego", 
        "state": "California"
    }, 
    {
        "city": "Dallas", 
        "state": "Texas"
    }, 
    {
        "city": "San Jose", 
        "state": "California"
    }, 
    {
        "city": "Austin", 
        "state": "Texas"
    }, 
    {
        "city": "Indianapolis", 
        "state": "Indiana"
    }, 
    {
        "city": "Jacksonville", 
        "state": "Florida"
    }, 
    {
        "city": "San Francisco", 
        "state": "California"
    }, 
    {
        "city": "Columbus", 
        "state": "Ohio"
    }, 
    {
        "city": "Charlotte", 
        "state": "North Carolina"
    }, 
    {
        "city": "Fort Worth", 
        "state": "Texas"
    }, 
    {
        "city": "Detroit", 
        "state": "Michigan"
    }, 
    {
        "city": "El Paso", 
        "state": "Texas"
    }, 
    {
        "city": "Memphis", 
        "state": "Tennessee"
    }, 
    {
        "city": "Seattle", 
        "state": "Washington"
    }, 
    {
        "city": "Denver", 
        "state": "Colorado"
    }, 
    {
        "city": "Washington", 
        "state": "District of Columbia"
    }, 
    {
        "city": "Boston", 
        "state": "Massachusetts"
    }, 
    {
        "city": "Nashville-Davidson", 
        "state": "Tennessee"
    }, 
    {
        "city": "Baltimore", 
        "state": "Maryland"
    }, 
    {
        "city": "Oklahoma City", 
        "state": "Oklahoma"
    }, 
    {
        "city": "Louisville/Jefferson County", 
        "state": "Kentucky"
    }, 
    {
        "city": "Portland", 
        "state": "Oregon"
    }, 
    {
        "city": "Las Vegas", 
        "state": "Nevada"
    }, 
    {
        "city": "Milwaukee", 
        "state": "Wisconsin"
    }, 
    {
        "city": "Albuquerque", 
        "state": "New Mexico"
    }, 
    {
        "city": "Tucson", 
        "state": "Arizona"
    }, 
    {
        "city": "Fresno", 
        "state": "California"
    }, 
    {
        "city": "Sacramento", 
        "state": "California"
    }, 
    {
        "city": "Long Beach", 
        "state": "California"
    }, 
    {
        "city": "Kansas City", 
        "state": "Missouri"
    }, 
    {
        "city": "Mesa", 
        "state": "Arizona"
    }, 
    {
        "city": "Virginia Beach", 
        "state": "Virginia"
    }, 
    {
        "city": "Atlanta", 
        "state": "Georgia"
    }, 
    {
        "city": "Colorado Springs", 
        "state": "Colorado"
    }, 
    {
        "city": "Omaha", 
        "state": "Nebraska"
    }, 
    {
        "city": "Raleigh", 
        "state": "North Carolina"
    }, 
    {
        "city": "Miami", 
        "state": "Florida"
    }, 
    {
        "city": "Oakland", 
        "state": "California"
    }, 
    {
        "city": "Minneapolis", 
        "state": "Minnesota"
    }, 
    {
        "city": "Tulsa", 
        "state": "Oklahoma"
    }, 
    {
        "city": "Cleveland", 
        "state": "Ohio"
    }, 
    {
        "city": "Wichita", 
        "state": "Kansas"
    }, 
    {
        "city": "Arlington", 
        "state": "Texas"
    }, 
    {
        "city": "New Orleans", 
        "state": "Louisiana"
    }, 
    {
        "city": "Bakersfield", 
        "state": "California"
    }, 
    {
        "city": "Tampa", 
        "state": "Florida"
    }, 
    {
        "city": "Honolulu", 
        "state": "Hawaii"
    }, 
    {
        "city": "Aurora", 
        "state": "Colorado"
    }, 
    {
        "city": "Anaheim", 
        "state": "California"
    }, 
    {
        "city": "Santa Ana", 
        "state": "California"
    }, 
    {
        "city": "St. Louis", 
        "state": "Missouri"
    }, 
    {
        "city": "Riverside", 
        "state": "California"
    }, 
    {
        "city": "Corpus Christi", 
        "state": "Texas"
    }, 
    {
        "city": "Lexington-Fayette", 
        "state": "Kentucky"
    }, 
    {
        "city": "Pittsburgh", 
        "state": "Pennsylvania"
    }, 
    {
        "city": "Anchorage", 
        "state": "Alaska"
    }, 
    {
        "city": "Stockton", 
        "state": "California"
    }, 
    {
        "city": "Cincinnati", 
        "state": "Ohio"
    }, 
    {
        "city": "St. Paul", 
        "state": "Minnesota"
    }, 
    {
        "city": "Toledo", 
        "state": "Ohio"
    }, 
    {
        "city": "Greensboro", 
        "state": "North Carolina"
    }, 
    {
        "city": "Newark", 
        "state": "New Jersey"
    }, 
    {
        "city": "Plano", 
        "state": "Texas"
    }, 
    {
        "city": "Henderson", 
        "state": "Nevada"
    }, 
    {
        "city": "Lincoln", 
        "state": "Nebraska"
    }, 
    {
        "city": "Buffalo", 
        "state": "New York"
    }, 
    {
        "city": "Jersey City", 
        "state": "New Jersey"
    }, 
    {
        "city": "Chula Vista", 
        "state": "California"
    }, 
    {
        "city": "Fort Wayne", 
        "state": "Indiana"
    }, 
    {
        "city": "Orlando", 
        "state": "Florida"
    }, 
    {
        "city": "St. Petersburg", 
        "state": "Florida"
    }, 
    {
        "city": "Chandler", 
        "state": "Arizona"
    }, 
    {
        "city": "Laredo", 
        "state": "Texas"
    }, 
    {
        "city": "Norfolk", 
        "state": "Virginia"
    }, 
    {
        "city": "Durham", 
        "state": "North Carolina"
    }, 
    {
        "city": "Madison", 
        "state": "Wisconsin"
    }, 
    {
        "city": "Lubbock", 
        "state": "Texas"
    }, 
    {
        "city": "Irvine", 
        "state": "California"
    }, 
    {
        "city": "Winston-Salem", 
        "state": "North Carolina"
    }, 
    {
        "city": "Glendale", 
        "state": "Arizona"
    }, 
    {
        "city": "Garland", 
        "state": "Texas"
    }, 
    {
        "city": "Hialeah", 
        "state": "Florida"
    }, 
    {
        "city": "Reno", 
        "state": "Nevada"
    }, 
    {
        "city": "Chesapeake", 
        "state": "Virginia"
    }, 
    {
        "city": "Gilbert", 
        "state": "Arizona"
    }, 
    {
        "city": "Baton Rouge", 
        "state": "Louisiana"
    }, 
    {
        "city": "Irving", 
        "state": "Texas"
    }, 
    {
        "city": "Scottsdale", 
        "state": "Arizona"
    }, 
    {
        "city": "North Las Vegas", 
        "state": "Nevada"
    }, 
    {
        "city": "Fremont", 
        "state": "California"
    }, 
    {
        "city": "Boise City", 
        "state": "Idaho"
    }, 
    {
        "city": "Richmond", 
        "state": "Virginia"
    }, 
    {
        "city": "San Bernardino", 
        "state": "California"
    }
]


// WEBPACK FOOTER //
// ./src/lib/places.js